import React, { useRef, useState } from 'react';
import CommonLayout from './CommonLayout';
import ReverseSearch from './TopView/reverse-search';
import ImageSearchContainer from '../Content-Monitoring/Cpns/ImageSearchContainer';
import { useTranslation } from 'next-i18next';
import { useIsMobile } from '@/hooks/useIsMobile';

/**
 * 反向搜索单独显示反向搜索的组件
 */
export default function LeakedPrivatePhotosContent({ data }: { data: any }) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [imageSearchUrl, setImageSearchUrl] = useState<string>('');
  const [isAgreePrivacy, setIsAgreePrivacy] = useState<boolean>(false);
  // eslint-disable-next-line
  const searchClickRef = useRef<((imageUrl: string) => void) | null>(null);
  const removeImageRef = useRef<(() => void) | null>(null);

  // TopView 中的自定义内容
  const topViewContent = (
    <ReverseSearch
      isSearching={isSearching}
      onSearchClick={(imageUrl: string) => searchClickRef.current?.(imageUrl)}
      imageSearchUrl={imageSearchUrl}
      setImageSearchUrl={setImageSearchUrl}
      onRegisterRemoveImage={(fn: () => void) => {
        removeImageRef.current = fn;
      }}
      reverseSearchTitle={t('Check If Your Photos Appear Online')}
      reverseSearchTitleFontSize={isMobile ? '20px' : '28px'}
      isAgreePrivacy={isAgreePrivacy}
      setIsAgreePrivacy={setIsAgreePrivacy}
    />
  );

  // TopView 后面的自定义内容
  const afterTopContent = (
    <div style={{ marginTop: '54px', padding: isMobile ? '0 5px' : '0' }}>
      <ImageSearchContainer
        isSearching={isSearching}
        setIsSearching={setIsSearching}
        onRegisterSearchClick={(fn) => {
          searchClickRef.current = fn;
        }}
        imageSearchUrl={imageSearchUrl}
        contentFunction="photo"
        setImageSearchUrl={setImageSearchUrl}
        onRemoveImage={() => removeImageRef.current?.()}
      />
    </div>
  );

  // WhatDoView 中的自定义内容
  const whatDoViewContent = (
    <ReverseSearch
      isSearching={isSearching}
      onSearchClick={(imageUrl: string) => searchClickRef.current?.(imageUrl)}
      imageSearchUrl={imageSearchUrl}
      setImageSearchUrl={setImageSearchUrl}
      onRegisterRemoveImage={(fn: () => void) => {
        removeImageRef.current = fn;
      }}
      reverseSearchTitle={t('Check Where Your Photos Appear and Start the Removal Process')}
      reverseSearchTitleFontSize={isMobile ? '20px' : '28px'}
      isAgreePrivacy={isAgreePrivacy}
      setIsAgreePrivacy={setIsAgreePrivacy}
    />
  );

  return (
    <CommonLayout
      data={data}
      topViewContent={topViewContent}
      afterTopContent={afterTopContent}
      whatDoViewContent={whatDoViewContent}
    />
  );
}
